import { useTheme } from "../hooks/useTheme";

const PencilGraphiteBackground = ({ intensity = "medium", className = "" }) => {
  const { theme } = useTheme();

  const intensityClasses = {
    light: "opacity-20",
    medium: "opacity-40",
    strong: "opacity-60",
  };

  return (
    <div className={`fixed inset-0 pointer-events-none z-0 ${className}`}>
      {/* Base gradient background */}
      <div className={`absolute inset-0 ${intensityClasses[intensity]}`}>
        {theme === "dark" ? (
          <div className="absolute inset-0 bg-gradient-to-br from-graphite-shadow via-graphite-steel to-graphite-charcoal" />
        ) : (
          <div className="absolute inset-0 bg-gradient-to-br from-graphite-platinum via-graphite-silver to-graphite-steel" />
        )}
      </div>

      {/* Organic diagonal pencil texture with subtle depth */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `
            repeating-linear-gradient(
              -15deg,
              transparent,
              transparent 24px,
              ${theme === "dark" ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.06)"} 24px,
              ${theme === "dark" ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.06)"} 25px,
              transparent 25px,
              transparent 35px,
              ${theme === "dark" ? "rgba(255,255,255,0.10)" : "rgba(0,0,0,0.10)"} 35px,
              ${theme === "dark" ? "rgba(255,255,255,0.10)" : "rgba(0,0,0,0.10)"} 36px,
              transparent 36px,
              transparent 48px,
              ${theme === "dark" ? "rgba(255,255,255,0.04)" : "rgba(0,0,0,0.04)"} 48px,
              ${theme === "dark" ? "rgba(255,255,255,0.04)" : "rgba(0,0,0,0.04)"} 49px,
              transparent 49px,
              transparent 68px,
              ${theme === "dark" ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)"} 68px,
              ${theme === "dark" ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)"} 69px
            ),
            repeating-linear-gradient(
              -17deg,
              transparent,
              transparent 42px,
              ${theme === "dark" ? "rgba(255,255,255,0.03)" : "rgba(0,0,0,0.03)"} 42px,
              ${theme === "dark" ? "rgba(255,255,255,0.03)" : "rgba(0,0,0,0.03)"} 43px,
              transparent 43px,
              transparent 64px,
              ${theme === "dark" ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)"} 64px,
              ${theme === "dark" ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)"} 65px
            )
          `,
        }}
      />
    </div>
  );
};

export default PencilGraphiteBackground;
